import { render, staticRenderFns } from "./KeyConfig.vue?vue&type=template&id=a76d63bc&scoped=true&"
import script from "./KeyConfig.vue?vue&type=script&lang=ts&"
export * from "./KeyConfig.vue?vue&type=script&lang=ts&"
import style0 from "./KeyConfig.vue?vue&type=style&index=0&id=a76d63bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76d63bc",
  null
  
)

export default component.exports